import React, { useState } from "react";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { getTranslate } from "react-localize-redux";
import axios from "axios";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { loaderMaskActions, msgActions } from "../../../../../../redux/actions";

function AddIssueButton({
  translate,
  user,
  subUser,
  isSubUser,
  location,
  dispatch,
}) {
  const [addIssueModal, setAddIssueModal] = useState(false);
  const [issueType, setIssueType] = useState("Issue");
  const [issueText, setIssueText] = useState("");

  const toggleAddIssueModal = () => {
    setAddIssueModal(!addIssueModal);
    setIssueType("Issue");
    setIssueText("");
  };

  const handleIssueTypeChange = (e) => {
    setIssueType(e.target.value);
  };

  const handleIssueTextChange = (e) => {
    setIssueText(e.target.value);
  };

  const handleReportIssue = (event) => {
    event.preventDefault();
    if (issueText && issueText.length > 10) {
      var currentUser = user,
        currentTabView = "files";
      if (isSubUser) {
        currentUser = subUser;
      }
      const { userId } = currentUser || {};
      if (location.pathname.startsWith("/files")) {
        currentTabView = "files";
      } else if (location.pathname.startsWith("/documents")) {
        currentTabView = "documents";
      } else if (location.pathname.startsWith("/flows")) {
        currentTabView = "flows";
      } else if (location.pathname.startsWith("/exec-reports")) {
        currentTabView = "exec-reports";
      } else if (location.pathname.startsWith("/config-reports")) {
        currentTabView = "config-reports";
      } else if (location.pathname.startsWith("/customers")) {
        currentTabView = "customers";
      } else if (location.pathname.startsWith("/dashboard")) {
        currentTabView = "dashboard";
      }
      const { detect } = require("detect-browser");
      const browser = detect();
      let _params = {
        Username: userId,
        Tab: currentTabView,
        ReportType: issueType,
        Message: issueText,
        BrowserVersion:
          browser && `${browser.name.toUpperCase()} Version ${browser.version}`,
      };
      dispatch(loaderMaskActions.show("Reporting a new issue..."));
      axios
        .post("Configuration/reportissuequestion", _params)
        .then((response) => {
          dispatch(loaderMaskActions.hide(""));
          var json = response.data;
          if (json.Errors && json.Errors.length) {
            dispatch(msgActions.error("Report Issue", json.Errors[0]));
            return;
          }
          dispatch(
            msgActions.success(
              "Report Issue",
              "Issue/Question reported successfully."
            )
          );
          toggleAddIssueModal();
        })
        .catch((error) => {
          dispatch(loaderMaskActions.hide(""));
          dispatch(msgActions.error("Report Issue", error));
        });
    } else {
      dispatch(
        msgActions.error(
          "Report Issue",
          "The issue Message must be at least 10 characters length."
        )
      );
    }
  };

  return (
    <>
      <button
        type="button"
        className="add-issue-btn"
        data-tip
        data-place="bottom"
        data-type="info"
        data-effect="solid"
        data-for="ReportIssueTip"
        onClick={toggleAddIssueModal}
      >
        <i className="fa fa-bug" style={{ padding: "0 10px" }} />
      </button>
      <ReactTooltip className="customeTheme" id="ReportIssueTip">
        <strong>{translate("Report issue/Ask question")}</strong>
      </ReactTooltip>
      <Modal isOpen={addIssueModal} toggle={toggleAddIssueModal}>
        <ModalHeader toggle={toggleAddIssueModal}>Report Issue</ModalHeader>
        <ModalBody>
          <Form id="__reportIssueForm">
            <FormGroup>
              <Label htmlFor="reportSelect">Report</Label>
              <Input
                type="select"
                name="reportType"
                id="reportSelect"
                value={issueType}
                onChange={handleIssueTypeChange}
              >
                <option>Issue</option>
                <option>Question</option>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label htmlFor="messageText">Message</Label>
              <Input
                type="textarea"
                name="message"
                id="messageText"
                value={issueText}
                onChange={handleIssueTextChange}
                required
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter className="text-center">
          <button
            type="submit"
            form="__reportIssueForm"
            className="btn btn-primary"
            onClick={handleReportIssue}
          >
            Add Issue
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

function mapStateToProps(state) {
  const { locale } = state;

  return {
    translate: getTranslate(locale),
  };
}

const connectedAddIssueButton = connect(mapStateToProps)(AddIssueButton);
export { connectedAddIssueButton as AddIssueButton };
